import { render } from "./iLikeButton.vue?vue&type=template&id=a7002368&scoped=true&ts=true"
import script from "./iLikeButton.vue?vue&type=script&lang=ts"
export * from "./iLikeButton.vue?vue&type=script&lang=ts"

import "./iLikeButton.vue?vue&type=style&index=0&id=a7002368&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7002368"]])

export default __exports__